import ContactUnlinked from './../models/ContactUnlinked';
import Base from './Base';

export default class ContactsUnlinked extends Base {
    get models() {
        const collection = this.data.map(item => new ContactUnlinked(item));
        collection.collection = this;

        return collection;
    }
}
